import React from "react";
import NotfoundImg from "../../Assets/404.png";
import classes from "./notfound.module.css";
function denied() {
    return (
        <div className={classes["wrapper"]}>
            <img src={NotfoundImg} alt="notfound" />
            <h3>PAGE NOT FOUND.</h3>
            <p>
                The page you are looking for might have been removed had its
                name changed or is temporarily unavailable.
            </p>
        </div>
    );
}

export default denied;
